import { FerryPreAddonType } from '@shared/interfaces/preCheckout';

interface ConfigBase {
    readonly isTest: boolean;
    readonly isDevelopment: boolean;
    readonly smallBagIncluded: boolean;
    readonly preCheckoutSupports: FerryPreAddonType[];
    readonly adyen: {
        readonly clientKey: string;
        readonly environment: string;
    };
    readonly tracking: {
        readonly enabled: boolean;
        readonly statsig: {
            readonly key: string;
            readonly environment: string;
        };
    };
    readonly devMode: {
        readonly enabled: boolean;
    };
    readonly sessionCartStorage: {
        readonly enabled: boolean;
    };
}

export const configBase: ConfigBase = {
    isTest: !!import.meta.env.TEST,
    isDevelopment: import.meta.env.NODE_ENV === 'development',
    smallBagIncluded: true,
    preCheckoutSupports: [
        FerryPreAddonType.Accommodation,
        FerryPreAddonType.Meal,
        FerryPreAddonType.Pet,
        FerryPreAddonType.Lounge,
    ],
    adyen: {
        clientKey: import.meta.env.VITE_ADYEN_CLIENT_KEY ?? '',
        environment: import.meta.env.VITE_ADYEN_ENVIRONMENT ?? '',
    },
    tracking: {
        enabled: import.meta.env.VITE_TRACKING_ENABLED === 'true',
        statsig: {
            key: import.meta.env.VITE_TRACKING_STATSIG_KEY ?? '',
            environment: import.meta.env.VITE_TRACKING_STATSIG_ENVIRONMENT ?? '',
        },
    },
    devMode: {
        enabled: import.meta.env.VITE_DEV_MODE_ENABLED === 'true',
    },
    sessionCartStorage: { enabled: true },
};
